module.exports = __webpack_public_path__ + "static/img/middle1.8d142f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle1.jpg
// module id = aWJ8
// module chunks = 9